module.exports = __webpack_public_path__ + "static/media/03.6f52c1f8.jpg";